import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/triangle-calculator',
  component: () => import('../../routes/TriangleCalculator.svelte'),
  card: {
    id: 'triangle-calculator',
    title: 'Triangle Calculator',
    description: 'Calculate all sides, angles, area, and perimeter of a triangle from any three known values. Supports SSS, SAS, and ASA/AAS modes.',
    icon: 'change_history',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/triangle-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Triangle Calculator – Find Sides, Angles, Area & Perimeter',
    description: 'Free triangle calculator. Enter any three known values (sides or angles) and instantly get all sides, angles, area, and perimeter using Law of Sines, Law of Cosines, and Heron\'s formula.',
  },
};

export default meta;
